<!--
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-07-05 13:52:43
 * @LastEditTime: 2019-08-14 13:36:15
 * @LastEditors: yingbin
 -->
<template>
  <div class="address">
    <div class="search">
      <el-input
        placeholder="可对收件人姓名，手机号进行搜索"
        v-model.trim="keyword"
        clearable
      >
        <template slot="append">
          <el-button
            @click="search"
            slot="append"
            :loading="isSearch"
            icon="el-icon-search"
            >搜索</el-button
          >
        </template>
      </el-input>
      <div class="itemView" style="font-size: 12px;cursor: pointer;" @click="goerrorTip" v-if="$store.state.teamModel=='2'">
         <span style="line-height: 40px; color: red; padding-left: 10px;">*</span>
         <span >
        团队共享地址仅允许团员本人修改和删除，其他团员仅可使用或复制</span>
        
       <i class="el-icon-question " style="color: #409EFF;"></i></div>
    </div>
    <div class="table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        height="400px"
        max-height="400px"
        size="mini"
        :border="false"
        empty-text=" "
        @selection-change="handleSelectionChange"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        @row-click="newpend"
      >
        <el-table-column
          type="selection"
          align="center"
          width="55"
          v-if="!forCustmer"
        ></el-table-column>
        <el-table-column
          type="index"
          align="center"
          width="100"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="姓名"
          width="180"
        >
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机"
          width="200"
        ></el-table-column>
        <el-table-column align="left" label="地址" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if='scope.row.account_id != account_id' size="mini">共享地址</el-tag>
            {{ scope.row.province_name }} {{ scope.row.city_name }}
            {{ scope.row.district_name }} {{ scope.row.address }}</template
          >
        </el-table-column>
        <div slot="empty" class="noBody" v-if="haveData">
          <img src="@/assets/images/nodata.png" alt="" />
        </div>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background=""
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <div slot="append" class="sure" type="primary">确定</div>
    </div>
    <div class="btn_list">
      <el-row>
        <el-button type="primary" :disabled="idDisabled" @click="finshChoice" size="mini"
          >完成选择</el-button
        >
        <el-button @click="colseChoice" size="mini">取消选择</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import home from "@/api/home";
import util from "@/util/util";

export default {
  name: "",
  data() {
    return {
      keyword: "", //搜索关键字
      isSearch: false, // 搜索加载
      total: 0,
      currentPage: 1,
      tableData: [],
      multipleSelection: [],
      preSelet:[],
      idDisabled: true,
      loading: true,
      haveData: false,
      account_id: util.getCookie("account_id")
    };
  },
  props:["IdList","forCustmer"],
  created() {
    this.getTableList(this.currentPage);
  },
  mounted: function() {
    //数据挂载
  },

  methods: {
    goerrorTip(){
      const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
      if(Obstruct){
        const Item = JSON.parse(Obstruct).teamAddress
        window.open(Item)
      }
    },
    init(list){
      let _this = this;
      this.IdList.forEach(item =>{
         list.forEach(el=>{
           if(item == el.id){
            _this.$refs.multipleTable.toggleRowSelection(el,true);
            _this.preSelet.push(el);
           }
         })
      })
    },
    /**获取收件列表 */
    getTableList(currentPage) {
      let self = this;
      self.loading = true;
      home.getAddressList(self, 0, currentPage).then(res => {
        if (res.success) {
          self.total = res.data.total;
          self.tableData = res.data.list;
          // self.init(res.data.list);
          self.loading = false;
          if (res.data.list.length > 0) {
            this.haveData = false;
          } else {
            this.haveData = true;
          }
          if(!this.forCustmer){
            this.$nextTick(()=>{
              self.init(res.data.list);  
            })            
          }

        } else {
          self.loading = false;
        }
      });
    },

    /**搜索收件人 */
    search() {
      let self = this;
      self.isSearch = true;
      self.loading = true;
      self.currentPage = 1;
      home.getAddressList(self, 0, self.currentPage).then(res => {
        self.isSearch = false;
        if (res.success) {
          self.loading = false;
          self.total = res.data.total;
          self.tableData = res.data.list;
          if (res.data.length > 0) {
            this.haveData = false;
          } else {
            this.haveData = true;
          }
        } else {
          self.loading = false;
        }
      });
    },

    /** 全选 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.idDisabled = false;
      } else {
        this.idDisabled = true;
      }
    },
    //列表点击
    newpend(row) {
      if(this.forCustmer){
        let parent = this.$parent.$parent;
        let clickItme = {
          name: row.name,
          id:row.id,
          phone: row.phone,
          province: row.province_name,
          province_code: row.province_code,
          city: row.city_name,
          city_code: row.city_code,
          area: row.district_name,
          area_code: row.district_code,
          address: row.address,
          pca: [row.province_code, row.city_code, row.district_code],
          address_id:row.id
        };
        parent.ruleForm.collect = clickItme;
        parent.dialog = false;
        parent.checkDizhi();
        parent.$refs.ruleForm.clearValidate();
      }else{
         this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    /**当前页数变化 */
    handleCurrentChange(val) {
      this.getTableList(val);
    },

    /**关闭选择 */
    colseChoice() {
      this.$refs.multipleTable.clearSelection();
      this.$parent.$parent.dialog = false;
    },
    //数组去重
    FilterByName(data, Name) {   //data是json对象，Name是根据什么字段去重
        var dest = [];
        for (var i = 0; i < data.length; i++) {
            var ai = data[i];
            if (i == 0) {
                dest.push(ai);
            } else {
                var filterData = dest.filter(function (e) {
                    return e[Name] == ai[Name];
                })
                if (filterData.length == 0) {
                    dest.push(ai);
                }
            }
        }
        return dest;
    },
    /**完成选择 */
    finshChoice() {
      let parent = this.$parent.$parent;
      let improtData = this.FilterByName([...this.multipleSelection,...this.preSelet],'id');
      console.log('improtData',improtData)
      if(improtData.length >30){
        this.$message.warning('单批添加最多支持30个收件人');
         return
      }
      if(parent.switchShow && parent.checkFiled()){
         this.$message.warning('已开启批货寄件功能，不支持同时选择多个收件人');
         return
      }
      parent.Added_Collect = [];
      if(parent.switchShow && !parent.checkFiled() && improtData.length >=2){
         this.$message.warning('已开启批货寄件功能，不支持同时选择多个收件人');
         return
      }
      parent.dialog = false;
      const checkQuery = improtData.map((el,index)=>{
        return{
          'index':index,
          'receiver_province':el.province_name,
          'receiver_city':el.city_name,
          'receiver_district':el.district_name,
          'receiver_address':el.address,
          'sender_province':parent.ruleForm.send.province,
          'sender_city':parent.ruleForm.send.city,
          'sender_district':parent.ruleForm.send.district,
          'sender_address':parent.ruleForm.send.address
        }
      })
      home.checkaddress(this,checkQuery).then(res=>{
        if(res.success){
        const checkRes = res.data;
        for(let i = 0,len = checkRes.length;i<len;i++){
          improtData[i].status_desc = checkRes[i].status_desc
        }
        }  
        improtData.forEach(item => {
          let it = {
            id:item.id,
            name: item.name,
            phone: item.phone,
            province: item.province_name,
            city: item.city_name,
            area: item.district_name,
            province_code: item.province_code,
            city_code: item.city_code,
            area_code: item.district_code,
            address: item.address,
            status_desc:item.status_desc|| '',
            pca: [item.province_code, item.city_code, item.district_code],
            teamData:item.account_id != this.account_id,
          };
          parent.Added_Collect.push(it);
        });
        if (parent.Added_Collect.length > 0) {
          parent.isAble = false;
        }
        parent.setPreSave();
        parent.restFiled();
        parent.changeTrigger("blur");
        parent.$refs.ruleForm.clearValidate();        
      })
    }
  }
};
</script>
<style lang="stylus" scoped>
.address {
  .search {
    width: 880px;
    margin: 0 auto;
  }

  .table {
    padding: 0 20px;
    margin-top: 20px;

    .newpend {
      cursor: pointer;
      color: #2288F8;
    }
  }

  .page {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    .sure {
      display: inline-block;
      width: 48px;
      height: 28px;
      margin: 0 5px;
      font-size: 12px;
      text-align: center;
      line-height: 28px;
      border-radius: 4px;
      border: 1px solid rgba(220, 220, 220, 1);
      cursor: pointer;
    }

    .sure:hover {
      background: #2288f8;
      border: 1px solid #2288f8;
      color: #fff;
    }
  }

  .btn_list {
    margin-top: 20px;

    .el-row {
      text-align: center;

      button {
        margin: 0 20px;
        padding: 12px 50px;
      }
    }
  }

  .noBody {
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    img {
      width: 255px;
      height: 255px;
    }

    p {
      margin-top: 30px;
    }
  }
}
</style>
